window.SanitaerSuche = (function () {

  function norm(s) {
    return String(s == null ? '' : s).toLowerCase()
      .replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss')
      .replace(/\s+/g, ' ');
  }

  function compact(s) {
    return norm(s).replace(/[^a-z0-9]/g, '');
  }

  function bild(url, breite) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + breite;
  }

  function prepare(p) {
    var blob = norm([p.t, p.s, p.v, p.y, p.g].join(' '));
    return {
      p: p, blob: blob, nt: norm(p.t), ns: norm(p.s),
      blobc: compact(blob), ntc: compact(p.t), nsc: compact(p.s),
      skus: String(p.s == null ? '' : p.s).split(/\s+/).filter(Boolean).map(compact)
    };
  }

  function loadIndex() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root)
      ? Shopify.routes.root.replace(/\/$/, '') : '';
    var baseUrl = root + '/pages/suchindex';
    return (async function () {
      var all = [], page = 1, guard = 0;
      while (page && guard < 25) {
        guard++;
        try {
          var r = await fetch(baseUrl + '?page=' + page);
          var d = JSON.parse(await r.text());
          all = all.concat(d.products || []);
          page = d.next;
        } catch (e) { break; }
      }
      return all.map(prepare);
    })();
  }

  function search(items, q, limit) {
    var nq = norm(String(q == null ? '' : q).trim());
    if (nq.length < 2) return [];
    var terms = nq.split(' ').filter(Boolean);
    var qc = compact(q);
    var termsc = terms.map(compact);
    var hits = [];

    for (var i = 0; i < items.length; i++) {
      var it = items[i], j;

      var exact = qc.length >= 4 && it.skus.indexOf(qc) > -1;
      if (!exact) {
        for (j = 0; j < termsc.length; j++) {
          if (termsc[j].length >= 4 && it.skus.indexOf(termsc[j]) > -1) { exact = true; break; }
        }
      }

      var ok = true, score = 0;
      for (j = 0; j < terms.length; j++) {
        var tm = terms[j];
        if (it.blob.indexOf(tm) === -1) { ok = false; break; }
        if (it.ns.indexOf(tm) > -1) score += 5;
        if (it.nt.indexOf(tm) === 0) score += 4;
        else if (it.nt.indexOf(tm) > -1) score += 3;
      }
      if (ok) { hits.push({ it: it, g: 0, s: score + (exact ? 12 : 0) }); continue; }

      var okc = true, sc = 0;
      for (j = 0; j < termsc.length; j++) {
        var tmc = termsc[j];
        if (!tmc || it.blobc.indexOf(tmc) === -1) { okc = false; break; }
        if (it.skus.indexOf(tmc) > -1) sc += 12;
        if (it.nsc.indexOf(tmc) > -1) sc += 5;
        if (it.ntc.indexOf(tmc) === 0) sc += 4;
        else if (it.ntc.indexOf(tmc) > -1) sc += 3;
      }
      var okq = qc.length >= 2 && it.blobc.indexOf(qc) > -1;
      var sq = 0;
      if (okq) {
        sq = it.skus.indexOf(qc) > -1 ? 12
           : (it.nsc.indexOf(qc) > -1 ? 5 : (it.ntc.indexOf(qc) === 0 ? 4 : 3));
      }
      if (okc || okq) { hits.push({ it: it, g: 1, s: Math.max(okc ? sc : 0, sq) }); }
    }

    hits.sort(function (a, b) { return (a.g - b.g) || (b.s - a.s); });
    var out = hits.map(function (h) { return h.it.p; });
    return limit ? out.slice(0, limit) : out;
  }

  return { norm: norm, compact: compact, bild: bild, prepare: prepare, loadIndex: loadIndex, search: search };
})();
